module.exports = {
  EndPoint: {
    Me: "https://touchmee-meeting-app.azurewebsites.net/api/v1/me",
    Login: "https://touchmee-tenant-app.azurewebsites.net/api/v1/login",
    Tenant: "https://touchmee-tenant-app.azurewebsites.net/api/v1/tenant",
    Room: "https://touchmee-meeting-app.azurewebsites.net/api/v1/rooms",
    RoomAttribute:
      "https://touchmee-meeting-app.azurewebsites.net/api/v1/roomattributes",
    Schedule:
      "https://touchmee-meeting-app.azurewebsites.net/api/v1/events/getschedule",
    Event: "https://touchmee-meeting-app.azurewebsites.net/api/v1/events",
    History: "https://touchmee-history-app.azurewebsites.net/api/v1/histories",
    Checkin: "https://touchmee-meeting-app.azurewebsites.net/api/v1/checkin",
    Checkout: "https://touchmee-meeting-app.azurewebsites.net/api/v1/checkout",
    Notification:
      "https://touchmee-notification-app.azurewebsites.net/api/v1/Tags"
  },
  Notification: {
    GoogleSenderId: "336827448184"
  },
  ApplicationInsights: {
    InstrumentationKey: "6ccd9b68-e90a-4330-a82a-57662d8e2c45"
  },
  PageUrl: {
    Terms: "https://www.touch-mee.net/landingpage/rules.html",
    Usage: "https://www.touch-mee.net/files/userguide.pdf",
    PrivacyPolicy: "https://www.touch-mee.net/landingpage/policy.html"
  }
};
